import { JsonPipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";

@Component({
    selector: "app-json-editor",
    templateUrl: "./json-editor.component.html",
    imports: [TranslateModule, SvgIconComponent, FormsModule, JsonPipe],
})
export class JsonEditorComponent {
    @Input() model: any;
    @Output() modelChange = new EventEmitter<any>();

    jsonData: string;
    isValidJson = true;
    isEditing = false;

    onInputChange(event: Event): void {
        try {
            JSON.parse((<HTMLInputElement>event.target).value);
            this.isValidJson = true;
        } catch (_error) {
            this.isValidJson = false;
        }
    }

    editObject(): void {
        this.jsonData = JSON.stringify(this.model, null, 2);
        this.isEditing = true;
    }

    updateObject(): void {
        if (this.isValidJson) {
            this.model = JSON.parse(this.jsonData);
            this.isEditing = false;
            this.modelChange.emit(this.model);
        }
    }

    getLineCount(): number {
        const lines = this.jsonData.split(/\r\n|\r|\n/);
        return lines.length;
    }
}
